import WithResolvedThemeCoinCell from '@/components/core/Table/CustomCells/WithResolvedThemeCoinCell';
import RankLabel from '@/components/RankLabel';
import { Rank } from '@/models/rank';
import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export const ranksColumns: TableGridColumn<Rank>[] = [
  {
    field: 'name',
    headerName: 'table_depth',
    renderCell: rank => <RankLabel rank={rank} />,
  },
  {
    field: 'experience',
    headerName: 'required_xp',
    valueFormatter: rank => getMoneyOrAmount(rank?.experience),
  },
  {
    field: 'bonus',
    headerName: 'level_up_bonus',
    renderCell: rank => (
      <WithResolvedThemeCoinCell value={getMoneyOrAmount(rank?.bonus)} />
    ),
  },
];
